<template>
  <report-section 
    title="频谱图" 
    class="rr-frequency-section"
  >
    <template v-slot:content>
      <div class="chart-container">
        <div class="frequency-chart" :id="chartId"></div>
        <div class="x-axis-label">(Hz)</div>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";

export default {
  components: {
    ReportSection
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      chartId: "rrFrequencyChart",
      chart: null
    };
  },

  mounted() {
    this.$nextTick(() => {
      const chartDom = document.getElementById(this.chartId);
      if (chartDom) {
        this.chart = this.$echarts.init(chartDom);
        this.drawFrequencyChart();
      }
    });
  },

  watch: {
    reportDetailModel() {
      if (this.chart) {
        this.drawFrequencyChart();
      }
    },
  },

  methods: {
    drawFrequencyChart() {
      const frequencyData = this.getFrequencyData();
      
      const option = {
        grid: {
          left: '8%',
          right: '5%',
          top: '8%',
          bottom: '12%'
        },
        xAxis: {
          type: 'category',
          data: frequencyData.frequencies,
          axisLine: {
            lineStyle: {
              color: '#BABABA'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 12,
            formatter: function(value, index) {
              const numValue = parseFloat(value);
              // 显示主要的频率刻度：0.0, 0.1, 0.2, 0.3, 0.4, 0.5
              if (numValue === 0.0 || 
                  Math.abs(numValue - 0.1) < 0.01 || 
                  Math.abs(numValue - 0.2) < 0.01 || 
                  Math.abs(numValue - 0.3) < 0.01 || 
                  Math.abs(numValue - 0.4) < 0.01 || 
                  Math.abs(numValue - 0.5) < 0.01) {
                return numValue.toFixed(1);
              }
              return '';
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#f0f0f0',
              type: 'solid'
            }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 200, // 根据图片调整最大值
          interval: 40, // Y轴间隔
          axisLine: {
            lineStyle: {
              color: '#BABABA'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 12
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#f0f0f0',
              type: 'solid'
            }
          }
        },
        series: [{
          name: '频谱',
          data: frequencyData.values,
          type: 'line',
          smooth: false, // 不平滑处理，保持原始数据形状
          lineStyle: {
            color: '#4A90E2',
            width: 1
          },
          symbol: 'none' // 不显示数据点
        }],
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            const param = params[0];
            return `频率: ${param.name} Hz<br/>功率谱密度: ${param.value.toFixed(2)}`;
          }
        }
      };

      this.chart.setOption(option);
    },

    getFrequencyData() {
      if (this.reportDetailModel?.hrvFrequencyData && Array.isArray(this.reportDetailModel.hrvFrequencyData) && this.reportDetailModel.hrvFrequencyData.length > 0) {
        // 处理真实数据
        const dataLength = this.reportDetailModel.hrvFrequencyData.length;
        
        // 生成对应的频率标签（0.0到0.5 Hz）
        const frequencies = this.reportDetailModel.hrvFrequencyData.map((_, index) => {
          // 频谱图通常频率范围是0到0.5Hz
          const frequency = (index / (dataLength - 1)) * 0.5;
          return frequency.toFixed(3);
        });
        
        return {
          frequencies: frequencies,
          values: this.reportDetailModel.hrvFrequencyData
        };
      }
      
      // 如果没有真实数据，返回空数据
      return {
        frequencies: [],
        values: []
      };
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style lang="scss" scoped>
.rr-frequency-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.chart-container {
  position: relative;
  width: 100%;
  height: 320px;
}

.frequency-chart {
  @include z-index-2;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.x-axis-label {
  position: absolute;
  right: 5%;
  bottom: 6%;
  font-size: 14px;
  color: #333;
  z-index: 10;
}

@media print {
  .rr-frequency-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
  
  .chart-container {
    height: 300px;
  }
  
  .x-axis-label {
    bottom: -2% !important;  // 在打印模式下进一步往下调整
  }
}
</style>
